/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsColorListItem,
    MelcoModelsColorListItemFromJSON,
    MelcoModelsColorListItemFromJSONTyped,
    MelcoModelsColorListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsUpdateColorCollection
 */
export interface MelcoModelsUpdateColorCollection {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUpdateColorCollection
     */
    name?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsColorListItem>}
     * @memberof MelcoModelsUpdateColorCollection
     */
    color_list?: Array<MelcoModelsColorListItem> | null;
}

export function MelcoModelsUpdateColorCollectionFromJSON(json: any): MelcoModelsUpdateColorCollection {
    return MelcoModelsUpdateColorCollectionFromJSONTyped(json, false);
}

export function MelcoModelsUpdateColorCollectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUpdateColorCollection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'color_list': !exists(json, 'color_list') ? undefined : (json['color_list'] === null ? null : (json['color_list'] as Array<any>).map(MelcoModelsColorListItemFromJSON)),
    };
}

export function MelcoModelsUpdateColorCollectionToJSON(value?: MelcoModelsUpdateColorCollection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'color_list': value.color_list === undefined ? undefined : (value.color_list === null ? null : (value.color_list as Array<any>).map(MelcoModelsColorListItemToJSON)),
    };
}


